import NotificationHeader from "./components/NotificationHeader";
import { useEffect, useState } from "react";
import {
  NotificationCategory,
  useNotifications,
} from "@/context/NotificationContext";
import NotificationCard from "./components/NotificationCard";
import ArrowDown from "@/assets/icons/ArrowDown.svg";
import Pagination from "@/components/ui/Pagination";
import { useAppSelector } from "@/redux/hooks/hooks";
import { useMarkAllAsReadMutation } from "@/redux/feature/notification/notificationApi";
import { handleApiRequest } from "@/utils/handleApiRequest";

const Notifications = () => {
  const {
    notifications,
    meta,
    page,
    setPage,
    totalUnreadNotifications,
    category,
    setCategory,
  } = useNotifications();
  const notificationCategoryOptions: {
    label: string;
    value: NotificationCategory;
    count?: number;
  }[] = [
    {
      label: "All",
      value: "all",
      // count: 0,
    },
    {
      label: "Unread",
      value: "unread",
      count: totalUnreadNotifications,
    },
    // {
    //   label: "Action Required",
    //   value: "action_required",
    //   count: totalUnreadNotifications,
    // },
  ];
  const [borderPosition, setBorderPosition] = useState(0);
  const [borderWidth, setBorderWidth] = useState(0);

  const [loading, setLoading] = useState(false);
  const userEmail = useAppSelector((state) => state.auth.user?.email);

  const [markAllAsReadMutation] = useMarkAllAsReadMutation();

  const handleMarkAsAllRead = async () => {
    const payload = {
      email: userEmail,
    };
    setLoading(true);
    await handleApiRequest({
      payload: payload,
      requestFunction: markAllAsReadMutation,
      onSuccess: (res) => {
        setLoading(false);
      },
      onError: (err) => {
        setLoading(false);
        console.log(err);
      },
    });
  };

  const hasUnreadNotifications = (Number(totalUnreadNotifications) || 0) > 0;

  // useEffect(() => {
  //   const activeTab = document.querySelector(
  //     `li[data-value="${category}"]`
  //   ) as HTMLElement;
  //   if (activeTab) {
  //     const { offsetLeft, offsetWidth } = activeTab;
  //     setBorderPosition(offsetLeft);
  //     setBorderWidth(offsetWidth);
  //   }
  // }, [category]);

  return (
    <div>
      <NotificationHeader />
      <section className="max-w-[668px] mx-auto mt-8 md:mt-[65px]">
        {/* tabs */}
        <div className="border-b border-[#E5E9EB] flex items-center justify-between">
          <div className="flex w-full justify-between items-center">
            <div className="flex">
              {notificationCategoryOptions.map((item, index) => (
                <button
                  key={item.value}
                  className={`text-sm font-medium leading-5 tracking-[-0.75%] px-4 py-3 
                flex items-center gap-x-2 relative transition-all duration-300 ease-out
                hover:bg-gray-50/30 border-b-2 whitespace-nowrap
                ${
                  category === item.value
                    ? "text-[#FF6600] border-b-[#FF6600]"
                    : "text-[#62636C] hover:text-[#FF6600]/70 border-b-transparent"
                }
              `}
                  onClick={() => setCategory(item.value)}
                >
                  <span>{item.label}</span>

                  {/* Badge */}
                  {item.count && (
                    <div className="bg-[#FF6600] size-7 flex items-center justify-center rounded-full text-white text-[13px] font-medium px-2 transition-transform duration-200 ease-out">
                      {item.count}
                    </div>
                  )}
                </button>
              ))}
            </div>

            <button
              onClick={handleMarkAsAllRead}
              disabled={!hasUnreadNotifications || loading}
              className={`px-4 py-3 text-sm font-medium transition-colors ${
                hasUnreadNotifications
                  ? "text-[#FF6600] hover:text-[#D94F00]"
                  : "cursor-not-allowed text-[#98A2B3]"
              }`}
            >
              {loading ? "Marking..." : "Mark all as read"}
            </button>
          </div>
        </div>

        {/* cards */}
        <div className="md:py-[34px] relative">
          <div
            key={category}
            className="transition-all duration-500 ease-out opacity-0 transform translate-y-4"
            style={{
              animation: "slideInUp 0.5s ease-out forwards",
            }}
          >
            {notifications.length > 0 ? (
              <div>
                {notifications.map((item, i) => (
                  <div
                    key={i}
                    className="opacity-0 transform translate-y-2 transition-all duration-300 ease-out"
                    style={{
                      animation: `fadeInUp 0.4s ease-out ${i * 0.1}s forwards`,
                    }}
                  >
                    <NotificationCard data={item} />
                  </div>
                ))}
              </div>
            ) : (
              <div
                className="flex items-center justify-center min-h-[200px] opacity-0 transform translate-y-4"
                style={{
                  animation: "slideInUp 0.5s ease-out forwards",
                }}
              >
                <div className="text-center text-gray-500">
                  <h2 className="text-lg font-medium">
                    You don't have any {category === "unread" && "unread"}{" "}
                    notifications
                  </h2>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="mb-20">
          <Pagination
            currentPage={page}
            setPage={setPage}
            totalPages={meta?.totalPages}
          />
        </div>
      </section>

      <style>{`
        @keyframes slideInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default Notifications;
